export const API_URL= process.env.REACT_APP_API_URL
export const API_URL_UM= process.env.REACT_APP_API_URL_UM
export const API_UM_SECRET= process.env.REACT_APP_API_UM_SECRET
export const APP_URL= process.env.REACT_APP_APP_URL
export const APPOINTMENT_EDIT_LIMIT= Number(process.env.REACT_APP_APPOINTMENT_EDIT_LIMIT)
export const TELEGRAM_BOT_USERNAME= process.env.REACT_APP_TELEGRAM_BOT_USERNAME
